export const needMoreHelpExampleData = {
  telephone: "+18889061888",
  telephoneText: "+1 888-906-1888"
};
